import { create } from 'zustand';
import dayjs from 'dayjs';
import LocalDateTime from '~/lib/localdatetime';

type ScheduleEditorModalState = {
    // Modal state
    open: boolean;
    scheduleId: string | null;
    type: 'practitioner' | 'equipment' | null;
    clickedDateRange: { start: LocalDateTime, end: LocalDateTime } | null;

    // Actions
    setOpen: (open: boolean) => void;
    setScheduleId: (scheduleId: string | null) => void;
    setType: (type: 'practitioner' | 'equipment' | null) => void;
    setClickedDateRange: (date: { start: LocalDateTime, end: LocalDateTime } | null) => void;
    reset: () => void;
};

export const useScheduleEditorModalStore = create<ScheduleEditorModalState>((set) => ({
    // Initial state
    open: false,
    scheduleId: null,
    type: null,
    clickedDateRange: null,

    // Actions
    setOpen: (open) => set({ open }),
    setScheduleId: (scheduleId) => set({ scheduleId }),
    setType: (type) => set({ type }),
    setClickedDateRange: (date) => set({ clickedDateRange: date }),
    reset: () => set({
        scheduleId: null,
        type: null,
        clickedDateRange: null,
    }),
}));